import { computed } from 'vue';
import { usePersonalSettings } from '@/composables/usePersonalSettings';

export const useDarkMode = () => {
  const { darkMode, setDarkMode } = usePersonalSettings();
  const isActive = computed(() => darkMode.value);

  return {
    isActive,
    setDarkMode,
  };
};
